export const state = function () {
  return {
    id: 0,
  }
}

export const mutations = {
  SET: function (state, id) {
    state.id = id
  },
}

export const actions = {
  FETCH: async function ({ commit, rootGetters, state }) {
    if (rootGetters["user/IS_BAND"] && !state.id) {
      try {
        const ret = (await this.$axios.$get("/band/band/select/")) || {}

        if (ret.id) commit("SET", ret.id)
        else commit("SET", 0)
        return ret
      } catch (err) {
        console.log(err)
      }
    }
  },
  PATCH: function ({ commit, dispatch, rootGetters }, id) {
    return new Promise((resolve, reject) => {
      if (rootGetters["user/IS_BAND"]) {
        this.$axios
          .$patch(
            "/band/band/select/",
            {
              band_id: id,
            },
            {
              headers: {
                "X-CSRFToken": this.$cookies.get("csrftoken"),
              },
            }
          )
          .then(() => {
            commit("SET", id)
            dispatch("user/GET_USER_SUB_COUNT", null, { root: true })
              .then(() => {
                resolve()
              })
              .catch((err) => {
                reject(err)
              })
          })
          .catch((err) => {
            console.log(err)
          })
      } else resolve()
    })
  },
  SELECT_FIRST: function ({ dispatch, rootGetters }) {
    if (rootGetters["user/band_set/LIVE_BANDS"].length)
      dispatch("PATCH", rootGetters["user/band_set/LIVE_BANDS"][0].id)
  },
  RESET: function ({ commit }) {
    commit("SET", 0)
  },
}

export const getters = {
  BAND_DATA: function (state, getters, rootState, rootGetters) {
    const bandSet = rootGetters["user/band_set/LIVE_BANDS"]

    if (state.id && bandSet) {
      const bandId = state.id

      for (let i = 0; i < bandSet.length; i++) {
        if (bandSet[i].id === bandId) return bandSet[i]
      }
    }
  },
  GET_PICTURE: function (state, getters, rootState, rootGetters) {
    return rootGetters["user/band_set/GET_BAND_PICTURE_FROM_ID"](state.id, {
      target: "profile_picture",
      size: "40_40",
    })
  },
}
